export default (self, tab) => {
  self.setValue('isOpen', true);
  self.setValue('activeTab', tab);
};
